import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { User, Mail, Phone, FileText } from 'lucide-react';

const CustomerInfo = ({ bookingData, onUpdate }) => {
  return (
    <div data-testid="customer-info-step">
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Your Details</h2>
      <p className="text-gray-600 mb-6">Please provide your contact information</p>

      <div className="space-y-6">
        <div>
          <Label htmlFor="name" className="flex items-center gap-2">
            <User className="w-4 h-4" />
            Full Name *
          </Label>
          <Input
            id="name"
            placeholder="John Smith"
            value={bookingData.customerName}
            onChange={(e) => onUpdate({ customerName: e.target.value })}
            data-testid="customer-name-input"
            className="mt-1"
          />
        </div>

        <div>
          <Label htmlFor="email" className="flex items-center gap-2">
            <Mail className="w-4 h-4" />
            Email Address *
          </Label>
          <Input
            id="email"
            type="email"
            placeholder="john.smith@example.com"
            value={bookingData.customerEmail}
            onChange={(e) => onUpdate({ customerEmail: e.target.value })}
            data-testid="customer-email-input"
            className="mt-1"
          />
        </div>

        <div>
          <Label htmlFor="phone" className="flex items-center gap-2">
            <Phone className="w-4 h-4" />
            Phone Number *
          </Label>
          <Input
            id="phone"
            type="tel"
            placeholder="01392 123456"
            value={bookingData.customerPhone}
            onChange={(e) => onUpdate({ customerPhone: e.target.value })}
            data-testid="customer-phone-input"
            className="mt-1"
          />
        </div>

        <div>
          <Label htmlFor="access-notes" className="flex items-center gap-2">
            <FileText className="w-4 h-4" />
            Access Notes (Optional)
          </Label>
          <Textarea
            id="access-notes"
            placeholder="Any special access instructions, gate codes, parking information, etc."
            value={bookingData.accessNotes}
            onChange={(e) => onUpdate({ accessNotes: e.target.value })}
            data-testid="access-notes-input"
            className="mt-1"
            rows={4}
          />
        </div>

        {/* GDPR Notice */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm">
          <p className="text-gray-700">
            <strong>Data Protection:</strong> We process your data in accordance with UK GDPR. Your information will be used to provide the service you've requested and will be stored securely. For full details, please see our{' '}
            <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:underline font-medium">
              Privacy Policy
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CustomerInfo;